import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import type { HLJSApi } from 'highlight.js';

export type CodeSnippetLanguage = 'javascript' | 'xml';

let highlighter: Promise<HLJSApi> | undefined;

function loadHighlighter(): Promise<HLJSApi> {
  highlighter ??= Promise.all([
    import('highlight.js/lib/core'),
    import('highlight.js/lib/languages/xml'),
    import('highlight.js/lib/languages/javascript'),
  ]).then(([core, xml, javascript]) => {
    const hljs = core.default;
    hljs.registerLanguage('xml', xml.default);
    hljs.registerLanguage('javascript', javascript.default);
    return hljs;
  });
  return highlighter;
}

@Component({
  selector: 'app-code-snippet',
  templateUrl: './code-snippet.component.html',
  styleUrl: './code-snippet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CodeSnippetComponent {
  readonly code = input<string | null>('');
  readonly language = input<CodeSnippetLanguage>('javascript');

  protected readonly highlightedHtml = signal<string | null>(null);

  constructor() {
    effect((onCleanup) => {
      const code = this.code() ?? '';
      const language = this.language();
      let current = true;
      onCleanup(() => (current = false));
      this.highlightedHtml.set(null);
      loadHighlighter()
        .then((hljs) => {
          if (current) {
            this.highlightedHtml.set(hljs.highlight(code, { language, ignoreIllegals: true }).value);
          }
        })
        .catch(() => {});
    });
  }
}
